/** @format */
import React, { FC, useEffect, useState } from 'react'
import {
  Dialog,
  Icon,
  Select,
  Table,
  TableColumn,
  Option,
  Timepicker,
  Spinner
} from '@king-design/react'
// import { Dialog } from 'kpc-react'
import styled from 'styled-components'
import { PeriodOpts, SuppressDurationOpts, EventRuleProps } from './constants'

interface BatchEditDialogProps {
  className?: string
  visible: boolean
  onOk: (data: any) => void
  onClose: () => void
}

const initBatchEditValues: Partial<EventRuleProps> = {
  effectBT: '00:00',
  effectET: '23:59',
  trigger: 1,
  period: undefined,
  accumulatedCount: 1,
  suppressDuration: 0
}

const BatchEditDialog: FC<BatchEditDialogProps> = ({ className, visible, onOk, onClose }) => {
  const [values, setValues] = useState<Partial<EventRuleProps>>(initBatchEditValues)

  const onTableChange = (value: Partial<EventRuleProps>) => {
    setValues(prev => {
      return { ...prev, ...value }
    })
  }

  useEffect(() => {
    if (!visible) {
      setValues(initBatchEditValues)
    }
  }, [visible])

  return (
    <Dialog
      title="批量编辑"
      value={visible}
      width={880}
      ok={() => {
        onOk(values)
      }}
      onChangeValue={show => {
        if (!show) {
          onClose()
        }
      }}
    >
      <div className={className}>
        <p className="haader_info">
          <Icon className="ion-information-circled" color="danger" />
          点击“确定”后，配置策略将对已勾选的多个事件生效。
        </p>
        <Table
          data={[values]}
          checkType="none"
          rowCheckable={false}
          type="grid"
          rowKey={({ effectBT }) => effectBT}
        >
          <TableColumn
            title="告警生效时间"
            width={180}
            key="effectBT"
            slotTemplate={([data]) => {
              const { effectBT, effectET } = data
              return (
                <Timepicker
                  width={160}
                  value={[effectBT, effectET]}
                  step="00:15:00"
                  range
                  valueFormat="HH:mm"
                  showFormat="HH:mm"
                  onChangeValue={value => {
                    onTableChange({ effectBT: value[0], effectET: value[1] })
                  }}
                />
              )
            }}
          />
          <TableColumn
            title="统计周期"
            key="period"
            width={150}
            slotTemplate={([data]) => {
              return data.accumulatedCount > 1 ? (
                <Select
                  width={130}
                  value={data.period}
                  onChangeValue={value => {
                    onTableChange({ period: value })
                  }}
                >
                  {Object.keys(PeriodOpts).map(key => (
                    <Option value={Number(key)} key={key}>
                      {PeriodOpts[key]}
                    </Option>
                  ))}
                </Select>
              ) : null
            }}
          />
          <TableColumn
            title="触发方式"
            key="trigger"
            width={150}
            slotTemplate={([data]) => {
              return (
                <Select
                  width={130}
                  value={data.period ? 2 : 1}
                  onChangeValue={value => {
                    const isTrigger = value === 1
                    onTableChange({
                      ...data,
                      period: isTrigger ? undefined : 300,
                      accumulatedCount: isTrigger ? 1 : 2
                    })
                  }}
                >
                  <Option value={1}>触发</Option>
                  <Option value={2}>累计触发</Option>
                </Select>
              )
            }}
          />
          <TableColumn
            title="持续周期数"
            key="accumulatedCount"
            width={153}
            slotTemplate={([data]) => {
              return (
                <>
                  <Spinner
                    width={50}
                    min={data.accumulatedCount === 1 ? 1 : 2}
                    max={180}
                    step={1}
                    forceStep
                    value={data.accumulatedCount}
                    disabled={data.accumulatedCount === 1}
                    onChangeValue={value => {
                      onTableChange({ accumulatedCount: value })
                    }}
                  ></Spinner>
                  次
                </>
              )
            }}
          />
          <TableColumn
            title="告警间隔"
            key="suppressDuration"
            width={180}
            slotTemplate={([data]) => {
              return (
                <Select
                  width={160}
                  value={data.suppressDuration}
                  onChangeValue={value => {
                    onTableChange({ suppressDuration: value })
                  }}
                >
                  {Object.keys(SuppressDurationOpts).map(key => (
                    <Option value={Number(key)} key={key}>
                      {SuppressDurationOpts[key]}
                    </Option>
                  ))}
                </Select>
              )
            }}
          />
        </Table>
      </div>
    </Dialog>
  )
}

export default styled(BatchEditDialog)`
  .haader_info {
    .k-icon {
      margin-right: 4px;
    }
  }
  .k-table {
    .k-spinner {
      margin-right: 6px;
    }
  }
`
